import { computed } from 'vue';
import { usePartnerConfigStore } from '@/stores/partnerConfig';
import { matchesInputPattern } from '@/utils/inputPattern';
import { useNoteStore } from '../stores/note.store';
import { usePatientStore } from '../stores/patient.store';

export function usePatientIdValidation() {
  const partnerConfigStore = usePartnerConfigStore();
  const patientStore = usePatientStore();
  const noteStore = useNoteStore();

  const identifier = computed(() => {
    const config = partnerConfigStore.demographicsIdentifier;
    return config?.panel === 'patient_id' ? config : null;
  });
  const patientIdMismatch = computed<boolean>(() => {
    const pattern = identifier.value?.validation;
    const id = patientStore.patient?.id;
    return Boolean(pattern && id && !matchesInputPattern(pattern, id));
  });
  const patientIdMissing = computed<boolean>(() => Boolean(identifier.value?.required && !patientStore.patient?.id));

  const patientIdBlocksCompletion = computed<boolean>(() => patientIdMismatch.value || patientIdMissing.value);
  const showPatientIdError = computed<boolean>(() => patientIdMismatch.value
    || (patientIdMissing.value && noteStore.clinicalNote.submitted));

  return { patientIdBlocksCompletion, showPatientIdError };
}
